import { RootState, useAppSelector } from '@core/store';
import { BANNER_HEIGHT } from '@features/dynamic-components/components/banner/constants';

import { NAVBAR_HEIGHT, SANDBOX_BANNER_HEIGHT } from '../constants';

const useContentTopOffset = () => {
  const bannerCount = useAppSelector(
    (state: RootState) =>
      state.dynamicComponents.banners.length +
      state.dynamicComponents.feStaticBanners.length
  );

  const isSandBoxEnv = process.env.REACT_APP_ENVIRONMENT === 'sandbox';
  const sandboxOffset = isSandBoxEnv ? SANDBOX_BANNER_HEIGHT : 0;
  const bannerOffset = bannerCount > 0 ? BANNER_HEIGHT : 0;

  return NAVBAR_HEIGHT + sandboxOffset + bannerOffset;
};

export default useContentTopOffset;
